<div class="maxContainerWidth">
    <div class="gridsWrap">
        <div class="gridBanner">
            <div class="profileWrap flex items-center">
                <img src="assets/images/case-study-page/profile.png" alt="">
                <div class="profileData flex items-center">
                    <p class="name text-white">
                        Name
                    </p>
                    <div class="divider"></div>
                    <p class="date text-white">
                        may 20,2022
                    </p>
                </div>

            </div>
            <h1>Instant & Upfront
                payment for COD
                orders</h1>
                <p class="text-white">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Condimentum mattis pellentesque id nibh tortor id aliquet
                </p>
        </div>
        <div class="subGridsWrap">
            <div class="grid">
                <div class="gridContent">
                    <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="26" viewBox="0 0 14 26" fill="none">
                            <path d="M0 17.3333H2.8C2.8 18.8933 4.718 20.2222 7 20.2222C9.282 20.2222 11.2 18.8933 11.2 17.3333C11.2 15.7444 9.744 15.1667 6.664 14.4011C3.696 13.6356 0 12.6822 0 8.66667C0 6.08111 2.058 3.88556 4.9 3.14889V0H9.1V3.14889C11.942 3.88556 14 6.08111 14 8.66667H11.2C11.2 7.10667 9.282 5.77778 7 5.77778C4.718 5.77778 2.8 7.10667 2.8 8.66667C2.8 10.2556 4.256 10.8333 7.336 11.5989C10.304 12.3644 14 13.3178 14 17.3333C14 19.9189 11.942 22.1144 9.1 22.8511V26H4.9V22.8511C2.058 22.1144 0 19.9189 0 17.3333Z" fill="white"/>
                            </svg>
                    </div>
                    <div class="title">
                        PKR 170M+
                    </div>
                    <div class="subtitle">
                        Value of upfront payments made
                    </div>
                </div>
            </div>
            <div class="grid">
                <div class="gridContent">
                    <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="26" viewBox="0 0 14 26" fill="none">
                            <path d="M0 17.3333H2.8C2.8 18.8933 4.718 20.2222 7 20.2222C9.282 20.2222 11.2 18.8933 11.2 17.3333C11.2 15.7444 9.744 15.1667 6.664 14.4011C3.696 13.6356 0 12.6822 0 8.66667C0 6.08111 2.058 3.88556 4.9 3.14889V0H9.1V3.14889C11.942 3.88556 14 6.08111 14 8.66667H11.2C11.2 7.10667 9.282 5.77778 7 5.77778C4.718 5.77778 2.8 7.10667 2.8 8.66667C2.8 10.2556 4.256 10.8333 7.336 11.5989C10.304 12.3644 14 13.3178 14 17.3333C14 19.9189 11.942 22.1144 9.1 22.8511V26H4.9V22.8511C2.058 22.1144 0 19.9189 0 17.3333Z" fill="white"/>
                            </svg>
                    </div>
                    <div class="title">
                        PKR 170M+
                    </div>
                    <div class="subtitle">
                        Value of upfront payments made
                    </div>
                </div>
            </div>
            <div class="grid">
                <div class="gridContent">
                    <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="26" viewBox="0 0 14 26" fill="none">
                            <path d="M0 17.3333H2.8C2.8 18.8933 4.718 20.2222 7 20.2222C9.282 20.2222 11.2 18.8933 11.2 17.3333C11.2 15.7444 9.744 15.1667 6.664 14.4011C3.696 13.6356 0 12.6822 0 8.66667C0 6.08111 2.058 3.88556 4.9 3.14889V0H9.1V3.14889C11.942 3.88556 14 6.08111 14 8.66667H11.2C11.2 7.10667 9.282 5.77778 7 5.77778C4.718 5.77778 2.8 7.10667 2.8 8.66667C2.8 10.2556 4.256 10.8333 7.336 11.5989C10.304 12.3644 14 13.3178 14 17.3333C14 19.9189 11.942 22.1144 9.1 22.8511V26H4.9V22.8511C2.058 22.1144 0 19.9189 0 17.3333Z" fill="white"/>
                            </svg>
                    </div>
                    <div class="title">
                        PKR 170M+
                    </div>
                    <div class="subtitle">
                        Value of upfront payments made
                    </div>
                </div>
            </div>
        </div>  
    </div>
</div>